export default __webpack_public_path__ + "static/promotional-illustration-99bd39a9833f1fa44394dc38f3b23bac.svg";